module.exports = __webpack_public_path__ + "static/media/ico-counter-minus.3239b652.svg";